import {store} from '../../../store/store';
import {matrixService} from '../../../services/matrixService';
import {endMatrixCall, getActiveDirectCall, getMatrixCallLocalMedia} from '../../../services/matrixCallService';
import {groupCallService} from '../../groupCalls/services/groupCallService';
import {loadDevicePreferences} from '../../groupCalls/services/devicePreferences';
import {isRoomMember, matrixIdForUser} from '../group/addPeople';
import {createCallEscalation} from './callEscalationFlow';

export const callEscalation = createCallEscalation({
    active: getActiveDirectCall,
    localMedia: getMatrixCallLocalMedia,
    localUserId: () => matrixService.getClient()?.getUserId() ?? null,
    memberName: (roomId, userId) => matrixService.getRoom(roomId)?.getMember(userId)?.name || userId,
    roomName: roomId => matrixService.getRoom(roomId)?.name || undefined,
    resolveMatrixId: matrixIdForUser,
    findOrCreateGroupRoom: async memberIds =>
        matrixService.findUnnamedGroupRoom([...memberIds], true) ?? await matrixService.createRoom({invite: [...memberIds]}),
    isJoined: isRoomMember,
    invitedBy: (roomId, userId) => {
        const member = matrixService.getRoom(roomId)?.getMember(userId);
        return member?.membership === 'invite' ? member.events.member?.getSender() : undefined;
    },
    joinRoom: async roomId => {
        await matrixService.getClient()?.joinRoom(roomId);
    },
    sendEvent: async (roomId, type, content) => {
        const client = matrixService.getClient();
        if (!client) {
            throw new Error('Matrix client unavailable');
        }
        await client.sendEvent(roomId, type as 'org.phonehq.call.escalate', content);
    },
    endDirectCall: matrixCallId => endMatrixCall(matrixCallId, store.dispatch),
    group: {
        isBusy: () => groupCallService.isBusy(),
        openLobby: (roomId, intent) => groupCallService.openLobby(roomId, intent),
        join: choice => groupCallService.join(choice),
        ringMembers: targets => groupCallService.ringMembers(targets),
        beginSwitch: switched => groupCallService.beginSwitch(switched),
        finishSwitch: failed => groupCallService.finishSwitch(failed),
        isInCall: roomId => {
            const state = groupCallService.call.getSnapshot();
            return state.roomId === roomId && (state.phase === 'joined' || state.phase === 'reconnecting');
        },
        summary: roomId => groupCallService.roomCalls.getSnapshot().get(roomId),
    },
    devices: loadDevicePreferences,
    now: () => Date.now(),
    sleep: ms => new Promise(resolve => window.setTimeout(resolve, ms)),
    schedule: (callback, ms) => {
        window.setTimeout(callback, ms);
    },
});
